/**
 * @file useClickOutside.js
 * @description Hook to call a handler when a mousedown happens outside a given ref.
 * Mirrors the existing behavior in components; no visual or functional change.
 */
import { useEffect } from 'react';

export default function useClickOutside(ref, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    const listener = (event) => {
      if (!ref?.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler, enabled]);
}
